/*
 * The CBD Hut — disclosure compatibility base
 *
 * share.js extends DetailsDisclosure. The desktop header no longer needs the
 * older generic disclosure controller, so keep only the small base required by
 * the Share product control. Idempotent because the share snippet can appear
 * more than once on a page.
 */
var DetailsDisclosure = window.DetailsDisclosure || class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle?.querySelector('summary')?.nextElementSibling || null;

    this.mainDetailsToggle?.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle?.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    window.setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || !this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations?.() || [];

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play?.());
    } else {
      this.animations.forEach((animation) => animation.cancel?.());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
};

window.DetailsDisclosure = DetailsDisclosure;

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}
